import * as React from 'react';
import { SVGProps } from 'react';

const IconThumbDownSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 2h-2v7.91h2V2ZM2 8.72c0 .7.573 1.28 1.273 1.28h4.015l-.604 3.454-.02.203c0 .261.109.503.28.675L7.62 15l4.011-4.74c.236-.23.37-.55.37-.9V3.28c0-.7-.57-1.28-1.27-1.28H5.182c-.528 0-.98.322-1.171.78L2.089 6.99c-.057.146-.089.295-.089.46v1.22h.006L2 8.72Z" />
  </svg>
);
export default IconThumbDownSizeS;
